<template>
  <div class="modal" style="position: fixed; top: 0; right: 0; height: 100vh; width: 100vw; z-index: 1000;">
    <div>
      <div class="z4 white-bg black modal-box col-12"  style="z-index: 1001; width: fit-content" :style="`max-width:${maxWidth}px;`">

        <!-- Modal received data for header area -->
        <div class="p2 white-bg z5 height-30 modal-header">
          <i
            @click="closeVueRapid"
            class="icon icon-cancel h3 right pointer black absolute"
          ></i>
        </div>

        <!-- Modal main data area  -->
        <div class="col-12 content" @dblclick="closeVueRapid">
          <div class="px2 pb2">
            <slot name="body"></slot>
          </div>
        </div>
      </div>

      <!-- Modal Closer outside area -->
      <div
        @click="closeVueRapid"
        class="full-height top-0 left-0 col-12 absolute modal outside"
        style="z-index: 1000"
      ></div>
    </div>
  </div>
</template>

<script>
import { inject } from 'vue';
export default {
   props: {
    maxWidth: {
      type: String,
      default: '1440'
    }
  },
  setup(){
    const showModal = inject('showModal')
    function closeVueRapid () {
  
       showModal.value = false;
    }
    return {
      closeVueRapid
    }
  },
  
};
</script>

<style lang="scss">
 .modal > div {
  width: 100%;
  min-height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  .modal-box {
    max-width: 1440px;
    margin: 0 30px;
  }
  .icon-cancel:hover,
  .icon-cancel:focus {
    color: red;
    text-decoration: none;
    cursor: pointer;
  }
  .outside{
    background-color: rgba(0,0,0,0.4);
  }
}
</style>